import React, { useEffect, useState } from "react";
import PageTitle from "../../../Module/pageTitle";
import LabelField from "../../../Component/labelField";
import AddMorebtn from "../../../Component/addMoreBtn";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  addConfigCoupon,
  getExamListNew,
  getParentCourseNew,
  getSectionList,
  uploadConfigCouponFile,
} from "../../../Action/courseAction";
import { useDispatch } from "react-redux";
import FormInputField from "../../../Component/FormInputField";
import Dropdown from "../../../Component/dropdown";
import SubmitButton from "../../../Component/SubmitButton";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import {
  pdf_size_150MB,
  pdf_size_1MB,
  validateIsFileImageType,
  validateIsFilePDFType,
} from "../../../Utils/validators";
import {
  validateIsFileImageTypeErrMsg,
  validateIsFilePDFTypeErrMsg,
} from "../../../Utils/errorMsg";
import { showErrorSnackbar } from "../../../Action/snackbarAction";
import { userActivityContent } from "../../../Action/actionFile";

const StudentCouponAdd = () => {
  const dispatch = useDispatch();
  const [discountVal, setDiscountVal] = useState("");
  //val
  const [exam, setExam] = useState("");
  const [examStream, setExamStream] = useState("");
  const [codeDuration, setCodeDuration] = useState("");
  const [messageId, setMessageId] = useState("");
  const [selectedPDF, setSelectedPDF] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [uploadedPdf, setUploadedPdf] = useState("");
  //list
  const [examList, setExamList] = useState([]);
  const [examStreamList, setExamStreamList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  //add more state
  const initialValueSection = {
    sectionVal: "",
    resetSection: false,
  };
  const [sectionData, setSectionData] = useState([initialValueSection]);

  let initialVal = {
    image: "",
    url: "",
  };
  const [morningUploadedData, setMorningUploadedData] = useState(initialVal);
  const [morningImage, setMorningImage] = useState("");
  const [eveningImage, setEveningImage] = useState("");
  const [eveningUploadedData, setEveningUploadedData] = useState(initialVal);
  const initialActivityVal = {
    image: "",
    imagePreview: "",
    textTwo: [""],
    textThree: [""],
    type: "",
  };

  const [activityData, setActivityData] = useState([initialActivityVal]);
  const [activityTypeList, setactivityTypeList] = useState([]);
  const resetData = () => {
    setExam("");
    setExamStream("");
    setCodeDuration("");
    setMessageId("");
    setDiscountVal("");
    setPdfUrl("");
    setSelectedPDF("");
    setExamList([]);
    setExamStreamList([]);
    setSectionList([]);
    setUploadedPdf("");
    setSectionData([
      {
        sectionVal: "",
      },
    ]);
    setMorningImage("");
    setMorningUploadedData(initialVal);
    setEveningImage("");
    setEveningUploadedData(initialVal);
    setActivityData([initialActivityVal]);
  };

  //change input fields
  const onChangeExam = (val) => {
    setExam(val);
    setExamStream("");
    setExamStreamList([]);
    if (val) {
      dispatch(
        getParentCourseNew(`${val._id}`, (res) => {
          setExamStreamList(res);
        }),
      );
    }
  };

  const onChangeExamStream = async (val) => {
    setExamStream(val);
  };

  const changeSections = async (val, index) => {
    let newArray = JSON.parse(JSON.stringify(sectionData));
    newArray[index].sectionVal = val;
    await setSectionData(newArray);
  };

  const handlePDFChange = (e) => {
    e.preventDefault();
    if (!validateIsFilePDFType(e)) {
      dispatch(showErrorSnackbar(validateIsFilePDFTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_150MB) {
      dispatch(showErrorSnackbar("File size should be less than 150 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setPdfUrl(reader.result);
        setSelectedPDF(file);
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadConfigCouponFile(file, (res) => {
          if (res) setUploadedPdf(res?.fullPath);
          else setUploadedPdf("");
        }),
      );
    }
  };

  const onChangeMorningImage = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setMorningImage(reader.result);
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadConfigCouponFile(file, (res) => {
          if (res)
            setMorningUploadedData((prev) => ({
              ...prev,
              image: res?.fullPath,
            }));
          else setMorningUploadedData(initialVal);
        }),
      );
    }
  };

  const onChangeMorningURL = (value) => {
    setMorningUploadedData((prev) => ({ ...prev, url: value }));
  };

  const onChangeEveningURL = (value) => {
    setEveningUploadedData((prev) => ({ ...prev, url: value }));
  };

  const onChangeEveningImage = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setEveningImage(reader.result);
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadConfigCouponFile(file, (res) => {
          if (res)
            setEveningUploadedData((prev) => ({
              ...prev,
              image: res?.fullPath,
            }));
          else setEveningUploadedData(initialVal);
        }),
      );
    }
  };

  const handleCloseSection = (index) => {
    const newArray = [...sectionData];
    if (index > -1) {
      newArray.splice(index, 1);
    }
    setSectionData(newArray);
  };
  const onChangeActivityImage = (e, activityIndex) => {
    e.preventDefault();

    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }

    if (e.target.files[0].size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
      return;
    }

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      const temp = [...activityData];
      temp[activityIndex].imagePreview = reader.result;
      setActivityData(temp);
    };

    reader.readAsDataURL(file);

    dispatch(
      uploadConfigCouponFile(file, (res) => {
        const temp = [...activityData];

        if (res) {
          temp[activityIndex].image = res.fullPath;
        } else {
          temp[activityIndex].image = "";
        }

        setActivityData(temp);
      }),
    );
  };
  const handleAddActivity = () => {
    if (activityData.length >= 10) {
      dispatch(showErrorSnackbar("Maximum 10 User Activities are allowed."));
      return;
    }

    setActivityData([
      ...activityData,
      {
        image: "",
        imagePreview: "",
        textTwo: [""],
        textThree: [""],
        type: "",
      },
    ]);
  };
  const handleRemoveActivity = (index) => {
    const temp = [...activityData];
    temp.splice(index, 1);
    setActivityData(temp);
  };
  const onChangeActivityType = (value, activityIndex) => {
    const temp = [...activityData];
    temp[activityIndex].type = value;
    setActivityData(temp);
  };
  const onChangeTextTwo = (activityIndex, textIndex, value) => {
    const temp = [...activityData];
    temp[activityIndex].textTwo[textIndex] = value;
    setActivityData(temp);
  };
  const addTextTwo = (activityIndex) => {
    const temp = [...activityData];
    temp[activityIndex].textTwo.push("");
    setActivityData(temp);
  };
  const removeTextTwo = (activityIndex, textIndex) => {
    const temp = [...activityData];

    if (temp[activityIndex].textTwo.length > 1) {
      temp[activityIndex].textTwo.splice(textIndex, 1);
    }

    setActivityData(temp);
  };
  const onChangeTextThree = (activityIndex, textIndex, value) => {
    const temp = [...activityData];
    temp[activityIndex].textThree[textIndex] = value;
    setActivityData(temp);
  };
  const addTextThree = (activityIndex) => {
    const temp = [...activityData];
    temp[activityIndex].textThree.push("");
    setActivityData(temp);
  };
  const removeTextThree = (activityIndex, textIndex) => {
    const temp = [...activityData];

    if (temp[activityIndex].textThree.length > 1) {
      temp[activityIndex].textThree.splice(textIndex, 1);
    }

    setActivityData(temp);
  };
  const renderParentExamSubExam = () => {
    return (
      <>
        <div className="">
          <div className="d-flex align-items-center col-md-6 col-12">
            <LabelField labelName={"Discount Value"} isRequired={true} />

            <FormInputField
              placeholder={"Enter Discount Value"}
              setInputText={(value) => setDiscountVal(value)}
              value={discountVal}
            />
          </div>
          <div className="d-flex align-items-center col-md-6 col-12">
            <LabelField labelName={"Exam Name"} isRequired={true} />

            <Dropdown
              labelName="Select Exam Name"
              setInputText={(value) => onChangeExam(value)}
              options={examList}
              value={exam}
            />
          </div>
          <div className="d-flex align-items-center col-md-6 col-12">
            <LabelField labelName={"Exam Stream"} isRequired={true} />

            <Dropdown
              labelName="Select Exam Stream"
              setInputText={(value) => onChangeExamStream(value)}
              options={examStreamList}
              value={examStream}
            />
          </div>
        </div>

        <div className="p-2 border border-1 rounded-2 col-md-6 col-12 mb-2">
          {sectionData?.map((item, index) => {
            const { sectionVal } = item;
            return (
              <div className="d-flex align-items-center" key={index}>
                <LabelField
                  labelName={
                    sectionData?.length > 1 ? `Section ${index + 1}` : `Section`
                  }
                  isRequired={true}
                />

                <Dropdown
                  labelName="Select Exam Stream"
                  setInputText={(value) => changeSections(value, index)}
                  options={sectionList}
                  value={sectionVal}
                />
                {sectionData?.length === 1 ? null : (
                  <HighlightOffIcon
                    className="cursor ms-2"
                    color="primary"
                    fontSize="small"
                    onClick={() => handleCloseSection(index)}
                  />
                )}
              </div>
            );
          })}
          <div className="col-12 d-flex justify-content-center justify-content-md-end mt-2">
            <AddMorebtn
              handleClick={() =>
                setSectionData([...sectionData, initialValueSection])
              }
            />
          </div>
        </div>

        <div className="d-flex align-items-center col-md-6 col-12">
          <LabelField labelName={"Code Duration"} isRequired={true} />

          <FormInputField
            placeholder={"Enter Code Duration"}
            setInputText={(value) => setCodeDuration(value)}
            value={codeDuration}
          />
        </div>
        <div className="d-flex align-items-center col-md-6 col-12">
          <LabelField labelName={"Message Template ID"} isRequired={true} />

          <FormInputField
            placeholder={"Enter message id"}
            setInputText={(value) => setMessageId(value)}
            value={messageId}
          />
        </div>
        <ImagePickerAndViewer
          labelName={"PDF Url"}
          value={pdfUrl}
          handleChange={(e) => handlePDFChange(e)}
          htmlFor={"pdf-upload"}
          doctype={"pdf"}
          selectedPDF={selectedPDF}
          isRequired={true}
        />
        <div className="col-md-6 col-12">
          <div className="d-flex align-items-center">
            <LabelField labelName={"Morning Message"} />

            <div className="row flex-grow-1 align-items-center">
              <div className="col-md-3 col-12">
                <ImagePickerAndViewer
                  value={morningImage}
                  handleChange={(e) => onChangeMorningImage(e)}
                  htmlFor={"morning-photo-upload"}
                  removelabel={true}
                />
              </div>

              <div className="col-md-9 col-12">
                <FormInputField
                  placeholder={"Enter Morning Url"}
                  setInputText={(value) => onChangeMorningURL(value)}
                  value={
                    morningUploadedData?.url ? morningUploadedData?.url : ""
                  }
                  isMandatary={morningImage ? true : false}
                  disabled={morningImage ? false : true}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-12 d-flex  align-items-center">
          <LabelField labelName={"Evening Message"} />
          <div className="row flex-grow-1 align-items-center">
            <div className="col-md-3 ">
              <ImagePickerAndViewer
                value={eveningImage}
                handleChange={(e) => onChangeEveningImage(e)}
                htmlFor={"evening-photo-upload"}
                removelabel={true}
              />
            </div>
            <div className="col-md-9 col-12">
              <FormInputField
                placeholder={"Enter Evening Url"}
                setInputText={(value) => onChangeEveningURL(value)}
                value={eveningUploadedData?.url ? eveningUploadedData?.url : ""}
                isMandatary={eveningImage ? true : false}
                disabled={eveningImage ? false : true}
              />
            </div>
          </div>
        </div>

        <div className="row g-2">
          <LabelField labelName={"User Activity"} />

          <div className="col-lg-7 col-md-9 col-12">
            {activityData.map((activity, activityIndex) => (
              <div
                key={activityIndex}
                className="border rounded p-3 mb-3 position-relative"
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="text-primary fw-bold  ">
                    {" "}
                    {activityIndex + 1}
                  </div>
                  {activityData.length > 1 && (
                    <HighlightOffIcon
                      className="cursor  "
                      style={{ right: 10, top: 10 }}
                      color="primary"
                      onClick={() => handleRemoveActivity(activityIndex)}
                    />
                  )}
                </div>

                {/* Image */}

                <div className="d-flex align-items-center mb-1">
                  <LabelField labelName={"Import Image"} isRequired={true} />

                  <ImagePickerAndViewer
                    value={activity.imagePreview}
                    handleChange={(e) =>
                      onChangeActivityImage(e, activityIndex)
                    }
                    htmlFor={`activity-image-${activityIndex}`}
                    removelabel={true}
                    isRequired={true}
                  />
                </div>

                {/* Text Two */}
                <div className="d-flex  align-items-center mb-1">
                  <LabelField labelName={"Text Two"} />
                  <div className="col-md-9">
                    {activity.textTwo.map((item, textIndex) => (
                      <div
                        className="d-flex align-items-center"
                        key={textIndex}
                      >
                        <div className="col-md-10">
                          <FormInputField
                            placeholder="Enter Text Two"
                            value={item}
                            setInputText={(value) =>
                              onChangeTextTwo(activityIndex, textIndex, value)
                            }
                          />
                        </div>

                        <div className="ms-2">
                          {activity.textTwo.length > 1 && (
                            <HighlightOffIcon
                              className="cursor"
                              color="primary"
                              onClick={() =>
                                removeTextTwo(activityIndex, textIndex)
                              }
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="d-flex justify-content-center justify-content-md-end mt-2">
                  <AddMorebtn handleClick={() => addTextTwo(activityIndex)} />
                </div>

                {/* Text Three */}
                <div className="d-flex  align-items-center mb-1">
                  <LabelField labelName={"Text Three"} />
                  <div className="col-md-9">
                    {activity.textThree.map((item, textIndex) => (
                      <div
                        className="d-flex align-items-center "
                        key={textIndex}
                      >
                        <div className="col-md-10">
                          <FormInputField
                            placeholder="Enter Text Three"
                            value={item}
                            setInputText={(value) =>
                              onChangeTextThree(activityIndex, textIndex, value)
                            }
                          />
                        </div>

                        <div className="ms-2">
                          {activity.textThree.length > 1 && (
                            <HighlightOffIcon
                              className="cursor"
                              color="primary"
                              onClick={() =>
                                removeTextThree(activityIndex, textIndex)
                              }
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="d-flex justify-content-center justify-content-md-end mt-2">
                  <AddMorebtn handleClick={() => addTextThree(activityIndex)} />
                </div>

                {/* Type */}

                <div className="d-flex align-items-center">
                  <LabelField labelName={"Type"} />

                  <Dropdown
                    labelName="Select Type"
                    options={activityTypeList}
                    value={activity.type}
                    setInputText={(value) =>
                      onChangeActivityType(value, activityIndex)
                    }
                  />
                </div>
              </div>
            ))}

            {activityData.length < 10 && (
              <div className="col-12 d-flex justify-content-center justify-content-md-end mt-2">
                <AddMorebtn handleClick={handleAddActivity} />
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newSectionArr = [];

    sectionData?.forEach((i) => {
      let section_val = i?.sectionVal?.type;

      if (!newSectionArr.includes(section_val)) {
        newSectionArr.push(section_val);
      }
    });

    const newUserActivityContent = [];

    activityData?.forEach((item) => {
      newUserActivityContent.push({
        image: item.image,
        textTwo: item.textTwo.filter((text) => text.trim() !== ""),
        textThree: item.textThree.filter((text) => text.trim() !== ""),
        type: item.type?.name,
      });
    });

    let reqBody = {
      discPer: discountVal,
      baseCourseId: examStream?._id,
      examTypeId: exam?._id,
      sectionType: newSectionArr,
      validHours: codeDuration,
      link: uploadedPdf,
      templateId: messageId,
      userActivityContent: newUserActivityContent,
    };

    // Morning Message
    if (morningImage) {
      reqBody["morningMessage"] = morningUploadedData;
    }

    // Evening Message
    if (eveningImage) {
      reqBody["eveningMessage"] = eveningUploadedData;
    }

    dispatch(
      addConfigCoupon(reqBody, () => {
        resetData();
      }),
    );
  };
  //hooks
  useEffect(() => {
    dispatch(
      getExamListNew((res) => {
        setExamList(res);
      }),
    );
    dispatch(
      getSectionList(
        "",
        (res) => {
          setSectionList(res?.data);
        },
        () => {},
      ),
    );
    dispatch(
      userActivityContent((res) => {
        setactivityTypeList(res?.data);
      }),
    );
  }, []);

  const validations = () => {
    let isValidate = false;

    // Morning Message Validation
    if (morningImage) {
      if (morningUploadedData?.image && morningUploadedData?.url) {
        isValidate = false;
      } else {
        isValidate = true;
      }
    }

    // Evening Message Validation
    if (eveningImage) {
      if (eveningUploadedData?.image && eveningUploadedData?.url) {
        isValidate = false;
      } else {
        isValidate = true;
      }
    }

    // User Activity Image Validation
    if (!isValidate) {
      const isImageMissing = activityData.some(
        (item) => !item.image || item.image.trim() === "",
      );

      if (isImageMissing) {
        isValidate = true;
      }
    }

    return isValidate;
  };

  return (
    <div className="contentBox">
      <PageTitle name={"STUDENT COUPON CODE"} />
      <div className="formDiv contentScrollbar">
        <div className="col-12 formWidth">
          <form onSubmit={(e) => handleSubmit(e)}>
            {renderParentExamSubExam()}
            <SubmitButton name="Submit" validations={validations()} />
          </form>
        </div>
      </div>
    </div>
  );
};

export default StudentCouponAdd;
